import ROUTES from "../../../constants/routes";
import { breadCrumb } from "../../../constants/commonConstants";

/*
 * The title and link shown in the admin top bar for each admin page. A LOOKUP, not a chain of `pathname === ... ? ... :` with "Users" as the fallback: that chain left Audit Log and
 * Cancellation Feedback showing "Users" (2026-08-07) and then did the same to the Growth page (Chris's staging screenshot, 2026-10-20: "Growth" highlighted, "Users" in the bar). Every admin
 * page must have an entry here; adminCrumb.test.ts fails if one of the pages in the sidebar does not.
 */
export const ADMIN_CRUMBS: Record<string, { to: string; label: string }> = {
  [ROUTES.ADMINDASHBOARD]: { to: ROUTES.ADMINDASHBOARD, label: breadCrumb.GROWTH },
  [ROUTES.USERS]: { to: ROUTES.USERS, label: breadCrumb.USERS },
  [ROUTES.ADMIN]: { to: ROUTES.ADMIN, label: breadCrumb.ADMIN },
  [ROUTES.DELETEDUSERS]: { to: ROUTES.DELETEDUSERS, label: breadCrumb.DELETED_USERS },
  [ROUTES.AUDITLOG]: { to: ROUTES.AUDITLOG, label: breadCrumb.AUDIT_LOG },
  [ROUTES.CANCELLATIONFEEDBACK]: { to: ROUTES.CANCELLATIONFEEDBACK, label: breadCrumb.CANCELLATION_FEEDBACK },
  [ROUTES.ONBOARDING_INSIGHTS]: { to: ROUTES.ONBOARDING_INSIGHTS, label: breadCrumb.ONBOARDING_INSIGHTS },
};

export const adminCrumbFor = (pathname: string): { to: string; label: string } => ADMIN_CRUMBS[pathname] ?? ADMIN_CRUMBS[ROUTES.USERS];
